import React from "react";
import { isEmpty, isNull } from "lodash";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataType } from "../../../utils";
import { faFilter, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { useRouterParams } from "../../../abstracts";
import { AddToolTip } from "../../../components";

const TargetDroppedOutputField = (props) => {
  const {
    index,
    objName,
    fieldName,
    mappedData,
    setFieldValue,
    dataTypeMisMatch,
    setClickToSelect,
    clickToSelect,
    setFieldArrayName,
    forFunction = false,
    isCollection,
  } = props;
  const { flow, profileId, mapType } = useRouterParams();
  return (
    <div>
      {!isEmpty(mappedData) && (
        <>
          <div className="dropped-card">
            <Card
              className={`cardCss ${forFunction ? "mini mb-0" : ""} ${
                isCollection ? "mapper-collection" : ""
              }`}
              style={{
                background: "#F7F7F7",
                cursor: "default",
              }}
            >
              <div className="fieldTitle">
                <span className="fieldText">
                  {mapType == 3 ? (
                    <AddToolTip name={mappedData.propertyName}>
                      {mappedData.propertyName.length > 12
                        ? `${mappedData.propertyName.slice(0, 12)}...`
                        : mappedData.propertyName}
                    </AddToolTip>
                  ) : (
                    mappedData.displayName
                  )}
                </span>
              </div>
              {/* <div className="columnTitle">
              <span className="columnText">{mappedData.order}</span>
            </div> */}
              <div className="sampleData">
                <span className="sampleDataText">
                  {!forFunction ? "Value : " : null}
                  <span className="sampleValueText">
                    <AddToolTip name={mappedData.datum ?? 1000}>
                      {mappedData.datum ?? 1000}
                    </AddToolTip>
                  </span>
                </span>
              </div>
              {isCollection && (
                <div
                  style={{ cursor: "pointer" }}
                  className="collectionFilterIcon"
                  onClick={() =>
                    setFieldValue(
                      isNull(index)
                        ? setFieldValue(
                            `${objName}.value.isCollectionParent`,
                            true
                          )
                        : setFieldValue(
                            `${fieldName}.value.isCollectionParent`,
                            true
                          )
                    )
                  }
                >
                  <FontAwesomeIcon
                    icon={faFilter}
                    style={{ cursor: "pointer" }}
                  />
                  <span class="filter-dot">●</span>
                </div>
              )}

              <div className="dataType" style={{ top: "30%", width: "10%" }}>
                <FontAwesomeIcon
                  icon={faTrashAlt}
                  size="25px"
                  color="#EB5757"
                  className="cursor-pointer"
                  onClick={() => {
                    isNull(index)
                      ? setFieldValue(`${objName}.value`, null)
                      : setFieldValue(`${fieldName}.value`, null);
                    setClickToSelect(false);
                    setFieldArrayName(null);
                  }}
                />
              </div>
            </Card>
          </div>
          {dataTypeMisMatch && (
            <div className="ft-10 error-text" style={{ lineHeight: "1rem" }}>
              DataType Mismatch
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default TargetDroppedOutputField;
